export const topResults = "fQMVRc";
export const allResults = "xDqb0b";
export const recentResults = "pseX6d";
export const queryOnTypeRecent = "Cqduob";
export const moreResults = "fQB0mb";
export const queryOnTypeMore = "y9Pone";
export const pinned = "Oy$hOd";
export default {topResults,allResults,recentResults,queryOnTypeRecent,moreResults,queryOnTypeMore,pinned};